import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="auto-submit"
export default class extends Controller {
  connect() {
    this.debouncedSubmit = debounce(this.submitForm.bind(this), 700);
  }

  handleInput() {
    this.debouncedSubmit();
  }

  submitForm() {
    this.element.closest('form').submit();
  }
}
function debounce(callback, delay) {
  let timeout;
  return function() {
    clearTimeout(timeout);
    timeout = setTimeout(callback, delay);
  }
}
